"use client";

import { LockedOverlay } from "./LockedOverlay";
import { FakeDataWatermark } from "./FakeDataWatermark";

const FAKE_STATS = [
  { label: "mentions", value: "1,247" },
  { label: "1d", value: "+12" },
  { label: "7d", value: "+86" },
  { label: "30d", value: "+341" },
];

const FAKE_EDGES = [
  "Phantom Odyssey",
  "Stellar Vanguard",
  "Crimson Protocol",
  "Neon Abyss Zero",
  "Ironclad Legacy",
  "Void Breakers",
  "Arctic Siege II",
];

export function LockedMltBlock() {
  return (
    <div data-nosnippet className="bg-[#16202d] rounded-lg border border-[#2a475e] p-3 md:p-6 space-y-3 md:space-y-4 relative overflow-hidden">
      {/* Fake content — blurred */}
      <div className="select-none blur-[6px] pointer-events-none relative">
        {/* Fake stats row */}
        <div className="grid grid-cols-4 divide-x divide-[#2a475e]">
          {FAKE_STATS.map((s) => (
            <div
              key={s.label}
              className="flex flex-col items-center justify-center text-center px-3 sm:px-4 py-2"
            >
              <div className="text-sm font-bold leading-tight text-[#66c0f4] sm:text-xl md:text-2xl">
                {s.value}
              </div>
              <div className="text-[10px] leading-tight text-[#8f98a0] sm:text-xs md:text-sm mt-1">
                {s.label}
              </div>
            </div>
          ))}
        </div>

        {/* Fake header */}
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-3 mt-4">
          <div>
            <h3 className="text-base md:text-lg font-semibold text-white">
              More Like This
            </h3>
            <p className="text-[#8f98a0] text-xs md:text-sm">
              Games that cite this title in their More Like This section.
            </p>
          </div>
          <div className="flex gap-1">
            {["7d", "1m", "3m", "All"].map((r) => (
              <div
                key={r}
                className="px-2.5 py-1 rounded text-xs bg-[#1b2838] text-[#8f98a0]"
              >
                {r}
              </div>
            ))}
          </div>
        </div>

        {/* Fake grid: edges + chart */}
        <div className="grid grid-cols-1 xl:grid-cols-[minmax(260px,360px)_1fr] gap-4 md:gap-6 mt-4">
          {/* Fake edges table */}
          <div className="bg-[#16202d] rounded-lg border border-[#2a475e] overflow-hidden min-h-[280px]">
            <div className="divide-y divide-[#2a475e]">
              {FAKE_EDGES.map((name) => (
                <div
                  key={name}
                  className="flex items-center gap-2 px-1.5 py-1"
                >
                  <div className="w-[104px] md:w-[120px] aspect-[184/69] rounded bg-[#1b2838] flex-shrink-0" />
                  <span className="text-sm font-medium text-[#66c0f4] truncate">
                    {name}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Fake chart */}
          <div className="bg-[#16202d] rounded-lg border border-[#2a475e] overflow-hidden min-h-[280px] flex items-center justify-center">
            <svg
              viewBox="0 0 400 200"
              className="w-full h-full px-6 py-8"
              preserveAspectRatio="none"
            >
              <polyline
                points="0,160 40,145 80,150 120,130 160,135 200,110 240,95 280,100 320,70 360,55 400,40"
                fill="none"
                stroke="#66c0f4"
                strokeWidth="2"
                opacity="0.5"
              />
              <linearGradient
                id="locked-chart-grad"
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop offset="0%" stopColor="#66c0f4" stopOpacity="0.15" />
                <stop offset="100%" stopColor="#66c0f4" stopOpacity="0" />
              </linearGradient>
              <polygon
                points="0,160 40,145 80,150 120,130 160,135 200,110 240,95 280,100 320,70 360,55 400,40 400,200 0,200"
                fill="url(#locked-chart-grad)"
              />
            </svg>
          </div>
        </div>
        <FakeDataWatermark />
      </div>

      {/* Lock overlay */}
      <LockedOverlay message="Sign in to see More Like This data" surface="game_mlt" />
    </div>
  );
}
